export default function (state, value) {
    state.paymentSystems = value;
}